export default __webpack_public_path__ + "static/media/icon-big-acquisto-88-px.abb0f691.svg";